import {useState, useCallback, useEffect} from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Stack from '@mui/material/Stack';
import DeleteIcon from '@mui/icons-material/Delete';
import Typography from '@mui/material/Typography';

function Zang({id, name, patch, syncPatch, helperText}) {
    console.log(`Zang ${id} rendering`)
    //console.log(`DEBUG ${JSON.stringify(propData)}`)

    // user editing text
    const handleText = useCallback((e) => {
        console.log(`Zang ${id} onchange handler`)
        syncPatch({text: e.target.value})
    }, [id])

    // user presses button to clear data
    const clear = useCallback(() => {
        console.log(`Zang ${id} button handler clear`)
        syncPatch({text: ""})
    }, [id])

    // user pressing button to set default text
    const salve = useCallback(() => {
        console.log(`Ordinary ${id} button handler missal`)
        syncPatch({text: HYMNS['salve']})
    }, [id])
    const ave = useCallback(() => {
        console.log(`Ordinary ${id} button handler missal`)
        syncPatch({text: HYMNS['ave']})
    }, [id])
    const alma = useCallback(() => {
        console.log(`Ordinary ${id} button handler missal`)
        syncPatch({text: HYMNS['alma']})
    }, [id])
    const regina = useCallback(() => {
        console.log(`Ordinary ${id} button handler missal`)
        syncPatch({text: HYMNS['regina']})
    }, [id])

    return (
        <Stack spacing={4}>
            <Typography variant="h4" gutterBottom>{name}</Typography>
            <ButtonGroup variant="outlined" fullWidth={true}>
                <Button onClick={clear} startIcon={<DeleteIcon />} variant="outlined"/>
                {
                    (id === 'Uittredezang') &&
                    <Button onClick={salve}>Salve</Button>
                }
                {
                    (id === 'Uittredezang') &&
                    <Button onClick={ave}>Ave</Button>
                }
                {
                    (id === 'Uittredezang') &&
                    <Button onClick={alma}>Alma</Button>
                }
                {
                    (id === 'Uittredezang') &&
                    <Button onClick={regina}>Regina</Button>
                }
            </ButtonGroup>
            <TextField value={patch.text} helperText={helperText} onChange={handleText} multiline maxRows={100} variant="filled" fullWidth/>
        </Stack>
    )
}

const HYMNS = {
    salve: `Salve, Regina, mater misericordiae; vita, dulcedo et spes nostra, salve.\n\nAd te clamamus exsules filii Hevae.\n\nAd te suspiramus gementes et flentes in hac lacrimarum valle.\n\nEia ergo, advocata nostra, illos tuos misericordes oculos ad nos converte.\n\nEt Iesum, benedictum fructum ventris tui, nobis post hoc exsilium ostende.\n\nO clemens, o pia, o dulcis Virgo Maria.`,
    ave: `Ave, Regina coelorum,\n\nAve, Domina Angelorum:\n\nSalve, radix, salve, porta\n\nEx qua mundo lux est orta:\n\nGaude, Virgo gloriosa,\n\nSuper omnes speciosa,\n\nVale, o valde decora,\n\nEt pro nobis Christum exora.`,
    alma: `Alma Redemptoris Mater, quae pervia coeli\n\nPorta manes, et stella maris, sucurre cadenti,\n\nSurgere qui curat populo: tu quae genuisti,\n\nNatura mirante, tuum sanctum Genitorem,\n\nVirgo prius ac posterius, Gabrielis ab ore\n\nSumens illud Ave, peccatorum miserere.`,
    regina: `Regina coeli, laetare, alleluia.\n\nQuia quem meruisti portare, alleluia.\n\nResurrexit, sicut dixit, alleluia.\n\nOra pro nobis Deum, alleluia.`,
}

export default Zang;